<template>
<div class="c_upgrade_w" :class="{'c_upgrade_w_show': showTokenDialog}"  @click.stop="hideTokenDialog">
  <div class="c_upgrade" @click.stop>
    <img :src="require('@/assets/acceeToken@2x.png')"
      class="vipicon"
      />
    <h2 class="title">{{$t('accessToken.title')}}</h2>
    <div class="text_1">
      {{$t('accessToken.tip_1')}}
      <!-- <a target="_blank" href="https://github.com/settings/tokens/new" class="text_1-link">
      👉{{$t('accessToken.tip_3')}}
      </a> -->
    </div>
    <a target="_blank" href="https://github.com/alianrock/LittleStar/wiki/Access-token-for-Little-Star" class="text_2">
     👉 {{$t('accessToken.tip_2')}}
    </a>
    <input v-model="token" type="text" class="input" placeholder="Please enter token">
    <div @click="setToken" class="btn">{{$t('accessToken.btn')}}</div>
  </div>
</div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  data() {
    return {
      token: '',
    }
  },
  computed: {
    ...mapState({
      showTokenDialog: state => state.showTokenDialog,
    }),
  },
  watch: {
    showTokenDialog(val) {
      if (val) {
        this.token = ''
      }
    },
  },
  methods: {
    ...mapMutations(['hideTokenDialog', 'user/setAccessToken']),
    setToken() {
      if (this.token) {
        this['user/setAccessToken'](this.token)
        this.hideTokenDialog()

        this.$toast({
          msg: this.$t('accessToken.saveTip'),
          isConfirm: true,
        }).then(() => {
        })
      } else {
        this.$toast({
          msg: this.$t('accessToken.inputTip'),
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c_upgrade_w{
  height: 100%;
  width: 100%;
  background: rgba(0,0,0,0.7);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  opacity: 0;
  visibility: hidden;
  transition: 0.2s ease;
  z-index: 301;
}
.c_upgrade_w_show{
  opacity: 1;
  visibility: visible;
  .c_upgrade{
    opacity: 1;
    visibility: visible;
    transform: translate3d(-50%, -50%, 0);
  }
}
.c_upgrade{
  opacity: 0;
  visibility: hidden;
  transition: 0.2s ease;
  background-image: linear-gradient(180deg, #FFFFFF 0%, #F4F4F4 100%, #FFFFFF 100%);
  border: 1px solid #A8A8A8;
  border-radius: 8px;
  width: 356px;
  padding: 0 20px 20px;
  box-sizing: border-box;
  border-radius: 8px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -40%, 0);
  z-index: 1;
  .vipicon{
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 0;
    width: 70px;
    transform: translate(-50%, -50%);
  }
  .input{
    /* Group 51 */
    height: 32px;
    background: #E5EAEC;
    border: 1px solid #DBDBDB;
    box-sizing: border-box;
    border-radius: 8px;
    font-size: 14px;
    display: flex;
    text-align: center;
    margin-top: 20px;
    width: 100%;
    color: #737373;
  }
  .title{
    text-align: center;
    font-size: 18px;
    margin-bottom: 14px;
    margin-top: 44px;
    color: #000;
    font-weight: normal;
  }
  .text_1{
    line-height: 16px;
    text-align: center;
    font-size: 14px;
    color: #737373;
    padding-bottom: 8px;
  }
  .text_2{
    font-size: 14px;
    color: #216BE0;
    text-align: center;
    line-height: 16px;
    padding-bottom: 10px;
    margin: 0 auto;
    display: block;
    text-align: center;
    text-decoration: unset;
    &:hover{
      text-decoration: underline;
    }
  }
  .btn{
    outline: none;
    display: block;
    background: #2E7FFF;
    box-shadow: 0 0 5px 0 rgba(91,91,91,0.50);
    border-radius: 999px;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    height: 32px;
    line-height: 32px;
    border-radius: 999px;
    margin: 0 auto;
    text-decoration: none;
    padding: 0;
    cursor: pointer;
    border: none;
    margin-top: 24px;
    &:hover{
      background-image: linear-gradient(180deg, #2772E9 0%, #216BE0 100%);
    }
  }
}
</style>
